import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
const SpinnerButton = ({ className }) => {
    const { t: translate } = useTranslation();
    return (_jsx("div", { children: _jsxs("button", { className: `btn btn-primary ${className}`, disabled: true, children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: translate("Loading") })] }) }));
};
export default SpinnerButton;
